let _bizmatesSiteBaseUrl = process.env['VUE_APP_BIZMATES_URL'] || null;
const isCmsPreview = window.location.href.indexOf("/cms-preview/") > -1;
const isNewStudentDashboard = window.location.href.indexOf("-student.dev.bizmates.jp") > -1;
export const appBizmatesUrl = (isNewStudentDashboard ? (process.env['VUE_APP_BIZMATES_STUDENT_URL'] || null) : (process.env['VUE_APP_BIZMATES_URL'] || null));
export const bizmatesSiteBaseUrl = appBizmatesUrl ? appBizmatesUrl.replace('#/$#', '') : (_bizmatesSiteBaseUrl ? _bizmatesSiteBaseUrl.replace('#/$#', '') : null);
export const bizmatesSiteHomeUrl = bizmatesSiteBaseUrl ? bizmatesSiteBaseUrl + '/MyBizmates/home' : null;
export const bizmatesSiteContactUrl = bizmatesSiteBaseUrl ? bizmatesSiteBaseUrl + '/MyBizmates/student/inquiry' : null;
export const bizmatesApiBaseUrl = bizmatesSiteBaseUrl ? bizmatesSiteBaseUrl + '/MyBizmates/api/mystage' : null;
export const bizmatesWordbookApiBaseUrl = bizmatesSiteBaseUrl ? bizmatesSiteBaseUrl + '/MyBizmates/api/wordbook' : null;
export const myStageApiBaseUrl = bizmatesSiteBaseUrl ? bizmatesSiteBaseUrl + '/MyBizmates/api/mystage' : null;
export const myStageCmsApiBaseUrl = bizmatesSiteBaseUrl ? process.env.VUE_APP_CMS_API_URL + '/mystage' : null;
export const myBizmatesApiBaseUrl = bizmatesSiteBaseUrl ? bizmatesSiteBaseUrl + '/MyBizmates/api' : null;
export const bizmatesGraphQlEndpoint = '/graphql';

export const publicKey = isCmsPreview ? process.env.VUE_APP_CMS_API_JWT_SECRET : process.env.VUE_APP_RSA_PUBLIC_KEY || null;

export const internetWarning = 2000;
export const internetError = 1000;

export const programs = {
  assessment: 0,
  bizmates: 1,
  other: 2,
  corporate: 3,
  assist_lesson: 4,
  discovery: 5
};

export const programDescription = {
  1: 'Bizmates Program',
  2: 'Other Programs',
  4: 'Assist Lesson',
  5: 'Bizmates Discovery'
};

export const mainPrograms = {
  1: { name: 'Bizmates Programs', prefix: 'bp' },
  2: { name: 'Other Programs', prefix: 'op' },
  4: { name: 'Assist Lesson', prefix: 'al' },
  5: { name: 'Bizmates Discovery', prefix: 'bd' }
};

export const providers = {
  agora: 'agora',
  skyway: 'skyway',
  awschime: 'awschime'
};

export const contractTypes = [
  {
    id: 0,
    label: 'B2C'
  },
  {
    id: 1,
    label: 'B2B'
  },
  {
    id: 2,
    label: 'B2B2C'
  }
];

export const timeSyncInterval = 900000; // 15 minutes in ms

export const lessonStatus = {
  scheduled: 1,
  ongoing: 2,
  finished: 3,
  warmup: 4
};

export const layoutStyle = {
  default: 1,
  material: 2, // larger lesson material view
  videoScreen: 3 // larger video/screen streaming view
};

export const eventType = {
  userJoined: 11,
  userLeft: 12,
  connectedRtc: 21,
  disconnectedRtc: 22
};

export const lessonResultCode = {
  PENDING_EMERGENCY: -2,
  TRAINER_REQUESTS_SKYPE: -1,
  NO_RESULT: 0,
  LESSON_TAUGHT: 1,
  STUDENT_NOSHOW: 2,
  STUDENT_ABSENT: 3,
  ABSENT_SUB: 4,
  STUDENT_CANCEL: 10,
  TRAINER_SUBSTITUTION: 11,
  ADMIN_CANCEL: 12,
  STUDENT_EMERGENCY: 20,
  ADMIN_EMERGENCY: 22
};

export const browsers= {
  chrome: 'Chrome',
  edge: 'Edge',
  firefox: 'Firefox',
  safari: 'Safari',
  mobileSafari: 'Mobile Safari'
};

export const supportedBrowsers = [
  {
    name: 'Chrome',
    label: 'Google Chrome',
    minVersion: 80,
    os: ['general', 'Windows', 'Mac OS'],
    downloadLink: 'https://www.google.com/intl/en/chrome/'
  },
  {
    name: 'Edge',
    label: 'Microsoft Edge',
    minVersion: 80,
    os: ['Windows'],
    downloadLink: 'https://www.microsoft.com/en-us/edge/'
  },
  {
    name: 'Firefox',
    label: 'Mozilla Firefox',
    minVersion: 74,
    os: ['general', 'Windows', 'Mac OS'],
    downloadLink: 'https://www.mozilla.org/en-US/firefox/all/#product-desktop-release/'
  },
  {
    name: 'Safari',
    label: 'Safari',
    minVersion: 13,
    os: ['Mac OS'],
    downloadLink: 'https://support.apple.com/downloads/safari/'
  },
  {
    name: 'Mobile Safari',
    label: 'Mobile Safari',
    minVersion: 13,
    os: ['iOS'],
    downloadLink: 'https://support.apple.com/downloads/iphone/'
  },
  {
    name: 'Chrome',
    label: 'Google Chrome',
    minVersion: 80,
    os: ['Android'],
    downloadLink:
      'https://play.app.goo.gl/?link=https://play.google.com/store/apps/details?id=com.android.chrome'
  }
];

export const internetStatus = {
  offline: 'offline',
  online: 'online'
};

export const videoType = {
  youtube: 1,
  jstream: 0
};

export const generateCount = 10;

export const jStreamEvents = {
  playing: 'playing',
  paused: 'paused',
  clicked: 'clicked',
  landing: 'landing'
}

export const vocabulary = {
  defaultCategory: 0
}

export const zoom = {
  out: 100,
  in: 200
};

export const evaluationCharacteristics = [
  {
    value: '特徴と違った',
    icon: 1,
    score: -1
  },
  {
    value: '判断不可',
    icon: 3,
    score: 0
  },
  {
    value: '特徴通り',
    icon: 5,
    score: 1
  }
];

export const evaluationLesson = [
  {
    value: '期待と違った',
    icon: 1,
    score: -1
  },
  {
    value: '判断不可',
    icon: 3,
    score: 0
  },
  {
    value: '期待通り',
    icon: 5,
    score: 1
  }
];

export const dayOfWeek = ['日曜', '月曜', '火曜', '水曜', '木曜', '金曜', '土曜'];
export const datePrefix = ['本日', '明日', '明後日'];

export const schedule = {
  morning: 1,
  noon: 2,
  night: 3
};

export const schedules = [
  {
    timeRange: '5:00〜11:55',
    icon: 'fa-sun-o',
    hours: ['05', '06', '07', '08', '09', '10', '11'],
    scheduleData: null
  },
  {
    timeRange: '12:00〜17:55',
    icon: 'fa-coffee',
    hours: ['12', '13', '14', '15', '16', '17', null],
    scheduleData: null
  },
  {
    timeRange: '18:00〜24:55',
    icon: 'fa-moon-o',
    hours: ['18', '19', '20', '21', '22', '23', '24'],
    scheduleData: null
  }
];

export const sliderDeviceSetting = {
  PC: {
    lazyLoad: 'progressive',
    swipe: false,
    slidesToShow: 3,
    slidesToScroll: 3,
    autoplay: false,
    autoplaySpeed: 3000,
    infinite: false,
    vertical: false,
    verticalSwiping: false,
    draggable: true,
    arrows: true
  },
  SP: {
    swipe: true,
    slidesToShow: 2,
    slidesToScroll: 2,
    autoplay: false,
    autoplaySpeed: 3000,
    infinite: true,
    vertical: false,
    verticalSwiping: false,
    draggable: true,
    arrows: false,
    variableWidth: true
  }
};


export const REVAMP_PREFIX = 'New';

export const errorCodes = {
  ME001: 'ME001',
  ME002: 'ME002',
  ME003: 'ME003',
  ME004: 'ME004'
}

export const materialIsTest = {
  true: 1,
  false: 0,
}

export const materialPreload = {
  default: 1,
}

export const PLATFORM = {
  skype: 1,
  mystage: 2
}

export const CUSTOMER_RATING = {
  veryBad: 1,
  bad: 2,
  neutral: 3,
  good: 4,
  veryGood: 5
}

export const CUSTOMER_FEEDBACK_Q4 = 17;
